import { BibleVersion } from '../types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BIBLE_API_BASE = 'https://bible-api.com';

const BOOK_ABBREVIATIONS: Record<string, string> = {
  'genesis': 'gen',
  'gen': 'gen',
  'exodus': 'exo',
  'exo': 'exo',
  'leviticus': 'lev',
  'lev': 'lev',
  'numbers': 'num',
  'num': 'num',
  'deuteronomy': 'deu',
  'deut': 'deu',
  'deu': 'deu',
  'joshua': 'jos',
  'josh': 'jos',
  'jos': 'jos',
  'judges': 'jdg',
  'judg': 'jdg',
  'jdg': 'jdg',
  'ruth': 'rut',
  'rut': 'rut',
  '1samuel': '1sa',
  '1sam': '1sa',
  '1sa': '1sa',
  '2samuel': '2sa',
  '2sam': '2sa',
  '2sa': '2sa',
  '1kings': '1ki',
  '1ki': '1ki',
  '2kings': '2ki',
  '2ki': '2ki',
  '1chronicles': '1ch',
  '1chr': '1ch',
  '1ch': '1ch',
  '2chronicles': '2ch',
  '2chr': '2ch',
  '2ch': '2ch',
  'ezra': 'ezr',
  'ezr': 'ezr',
  'nehemiah': 'neh',
  'neh': 'neh',
  'esther': 'est',
  'est': 'est',
  'job': 'job',
  'psalms': 'psa',
  'psalm': 'psa',
  'psa': 'psa',
  'ps': 'psa',
  'proverbs': 'pro',
  'prov': 'pro',
  'pro': 'pro',
  'ecclesiastes': 'ecc',
  'eccl': 'ecc',
  'ecc': 'ecc',
  'songofsolomon': 'sng',
  'song': 'sng',
  'sng': 'sng',
  'isaiah': 'isa',
  'isa': 'isa',
  'jeremiah': 'jer',
  'jer': 'jer',
  'lamentations': 'lam',
  'lam': 'lam',
  'ezekiel': 'ezk',
  'ezek': 'ezk',
  'ezk': 'ezk',
  'daniel': 'dan',
  'dan': 'dan',
  'hosea': 'hos',
  'hos': 'hos',
  'joel': 'jol',
  'jol': 'jol',
  'amos': 'amo',
  'amo': 'amo',
  'obadiah': 'oba',
  'oba': 'oba',
  'jonah': 'jon',
  'jon': 'jon',
  'micah': 'mic',
  'mic': 'mic',
  'nahum': 'nam',
  'nah': 'nam',
  'nam': 'nam',
  'habakkuk': 'hab',
  'hab': 'hab',
  'zephaniah': 'zep',
  'zeph': 'zep',
  'zep': 'zep',
  'haggai': 'hag',
  'hag': 'hag',
  'zechariah': 'zec',
  'zech': 'zec',
  'zec': 'zec',
  'malachi': 'mal',
  'mal': 'mal',
  'matthew': 'mat',
  'matt': 'mat',
  'mat': 'mat',
  'mark': 'mrk',
  'mrk': 'mrk',
  'luke': 'luk',
  'luk': 'luk',
  'john': 'jhn',
  'jhn': 'jhn',
  'acts': 'act',
  'act': 'act',
  'romans': 'rom',
  'rom': 'rom',
  '1corinthians': '1co',
  '1cor': '1co',
  '1co': '1co',
  '2corinthians': '2co',
  '2cor': '2co',
  '2co': '2co',
  'galatians': 'gal',
  'gal': 'gal',
  'ephesians': 'eph',
  'eph': 'eph',
  'philippians': 'php',
  'phil': 'php',
  'php': 'php',
  'colossians': 'col',
  'col': 'col',
  '1thessalonians': '1th',
  '1thess': '1th',
  '1th': '1th',
  '2thessalonians': '2th',
  '2thess': '2th',
  '2th': '2th',
  '1timothy': '1ti',
  '1tim': '1ti',
  '1ti': '1ti',
  '2timothy': '2ti',
  '2tim': '2ti',
  '2ti': '2ti',
  'titus': 'tit',
  'tit': 'tit',
  'philemon': 'phm',
  'phlm': 'phm',
  'phm': 'phm',
  'hebrews': 'heb',
  'heb': 'heb',
  'james': 'jas',
  'jas': 'jas',
  '1peter': '1pe',
  '1pet': '1pe',
  '1pe': '1pe',
  '2peter': '2pe',
  '2pet': '2pe',
  '2pe': '2pe',
  '1john': '1jn',
  '1jn': '1jn',
  '2john': '2jn',
  '2jn': '2jn',
  '3john': '3jn',
  '3jn': '3jn',
  'jude': 'jud',
  'jud': 'jud',
  'revelation': 'rev',
  'rev': 'rev'
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FREE_VERSION_MAP: Record<string, string> = {
  'KJV': 'kjv',
  'WEB': 'web',
  'YLT': 'ylt',
  'ASV': 'asv',
  'BBE': 'bbe',
  'DARBY': 'darby'
};

// All versions are now supported by the Bible API (no API key needed)

export const BIBLE_VERSIONS: { value: BibleVersion; label: string }[] = [
  { value: 'KJV', label: 'King James Version (KJV)' },
  { value: 'WEB', label: 'World English Bible (WEB)' },
  { value: 'ASV', label: 'American Standard Version (ASV)' },
  { value: 'BBE', label: 'Bible in Basic English (BBE)' },
  { value: 'DARBY', label: 'Darby Translation' },
  { value: 'YLT', label: "Young's Literal Translation (YLT)" },
  { value: 'ESV', label: 'English Standard Version (ESV)' },
  { value: 'NASB', label: 'New American Standard Bible (NASB)' },
  { value: 'NLT', label: 'New Living Translation (NLT)' },
  { value: 'NKJV', label: 'New King James Version (NKJV)' },
  { value: 'NIV', label: 'New International Version (NIV)' },
  { value: 'CSB', label: 'Christian Standard Bible (CSB)' }
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface BibleApiResponse {
  reference: string;
  verses: Array<{
    book_id: string;
    book_name: string;
    chapter: number;
    verse: number;
    text: string;
  }>;
  text: string;
  translation_id: string;
  translation_name: string;
  translation_note: string;
}

// Hardcode your API key here for convenience
const HARDCODED_API_KEY = 'l3kdbfUARxEkVQhp-Lp6H';

let apiKey: string | null = null;

export const setApiBibleKey = (key: string) => {
  apiKey = key;
  if (typeof window !== 'undefined') {
    localStorage.setItem('api-bible-key', key);
  }
};

export const getApiBibleKey = (): string | null => {
  if (apiKey) return apiKey;
  
  // Use hardcoded key if available
  if (HARDCODED_API_KEY && HARDCODED_API_KEY.length > 20) {
    return HARDCODED_API_KEY;
  }
  
  if (typeof window !== 'undefined') {
    apiKey = localStorage.getItem('api-bible-key');
  }
  return apiKey;
};

// Cache for resolved Bible IDs
let cachedBibleIds: Record<string, string> | null = null;

// Auto-fetch available bibles on load to populate cache and log for debugging
const initBibleCache = async () => {
  const key = getApiBibleKey();
  if (!key) return;
  try {
    const res = await fetch('https://rest.api.bible/v1/bibles', { headers: { 'api-key': key } });
    if (!res.ok) { console.warn('Could not init bible cache:', res.status); return; }
    const data = await res.json();
    const bibles: any[] = data.data || [];
    cachedBibleIds = {};
    for (const b of bibles) {
      const abbr = (b.abbreviation || b.abbreviationLocal || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (abbr) cachedBibleIds[abbr] = b.id;
    }
  } catch (e) {
    console.warn('Bible cache init failed:', e);
  }
};
initBibleCache();

// Verified Bible IDs from rest.api.bible
const PREMIUM_VERSION_IDS: Partial<Record<BibleVersion, string>> = {
  'NIV':  '78a9f6124f344018-01',  // New International Version 2011
  'NKJV': '63097d2a0a2f7db3-01',  // New King James Version
  'NLT':  'd6e14a625393b4da-01',  // New Living Translation
  'ESV':  '06b25bbd844c0abf5-01', // English Standard Version (if available on plan)
  'NASB': '5d915c67c5c5d0c9-01',  // NASB (if available on plan)
  'CSB':  'c315fa9f71d4af3a-01',  // CSB (if available on plan)
};

const getApiBibleVersionId = async (version: BibleVersion, key: string): Promise<string> => {
  // Use hardcoded IDs for known versions
  if (PREMIUM_VERSION_IDS[version]) return PREMIUM_VERSION_IDS[version]!;

  // Fall back to dynamic lookup via cache
  if (cachedBibleIds) {
    if (cachedBibleIds[version]) return cachedBibleIds[version];
    const startsWithKey = Object.keys(cachedBibleIds).find(k => k.startsWith(version));
    if (startsWithKey) return cachedBibleIds[startsWithKey];
  }

  // Last resort: fetch bibles list
  const biblesResponse = await fetch('https://rest.api.bible/v1/bibles', {
    headers: { 'api-key': key }
  });
  if (!biblesResponse.ok) {
    const errorText = await biblesResponse.text();
    throw new Error(`API key validation failed: ${biblesResponse.status} - ${errorText}`);
  }
  const bibles: any[] = (await biblesResponse.json()).data || [];
  cachedBibleIds = {};
  for (const b of bibles) {
    const abbr = (b.abbreviation || b.abbreviationLocal || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (abbr) cachedBibleIds[abbr] = b.id;
  }
  if (cachedBibleIds[version]) return cachedBibleIds[version];
  const startsWithKey = Object.keys(cachedBibleIds).find(k => k.startsWith(version));
  if (startsWithKey) return cachedBibleIds[startsWithKey];

  throw new Error(`Version ${version} not found in your API plan.`);
};

const fetchFromApiBible = async (
  book: string,
  chapter: number,
  verse: number,
  version: BibleVersion
): Promise<string> => {
  const key = getApiBibleKey();
  if (!key) throw new Error('API key is required for this version');

  const bookKey = book.toLowerCase().replace(/\s+/g, '');
  const bookAbbr = BOOK_ABBREVIATIONS[bookKey] || bookKey;

  // Free versions use GitHub raw API
  const freeVersions: BibleVersion[] = ['KJV', 'WEB', 'ASV', 'BBE', 'YLT', 'DARBY'];
  if (freeVersions.includes(version)) {
    const freeMap: Record<string, string> = {
      'KJV': 'en-kjv', 'WEB': 'en-web', 'ASV': 'en-asv',
      'BBE': 'en-bbe', 'YLT': 'en-ylt', 'DARBY': 'en-darby'
    };
    const url = `https://raw.githubusercontent.com/wldeh/bible-api/master/bibles/${freeMap[version]}/books/${bookAbbr}/chapters/${chapter}/verses/${verse}.json`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch verse: ${response.status}`);
    const data = await response.json();
    return data.text?.trim() || '';
  }

  // Premium versions use rest.api.bible
  const versionId = await getApiBibleVersionId(version, key);
  const url = `https://rest.api.bible/v1/bibles/${versionId}/verses/${bookAbbr}.${chapter}.${verse}?content-type=text&include-notes=false&include-titles=false&include-chapter-numbers=false&include-verse-numbers=false&include-verse-spans=false`;

  const response = await fetch(url, { headers: { 'api-key': key } });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('Bible API Error:', response.status, errorText);
    throw new Error(`Failed to fetch verse: ${response.status} - ${errorText}`);
  }

  const data = await response.json();
  return data.data?.content?.replace(/<[^>]*>/g, '').trim() || '';
};

export const listAvailableBibles = async (): Promise<void> => {
  const key = getApiBibleKey();
  if (!key) { console.error('No API key set'); return; }
  const res = await fetch('https://rest.api.bible/v1/bibles', { headers: { 'api-key': key } });
  const data = await res.json();
  const bibles = (data.data || []).map((b: any) => ({ id: b.id, name: b.name, abbr: b.abbreviation }));
  console.table(bibles);
};

export const fetchBibleVerse = async (
  book: string,
  chapter: number,
  verse: number,
  version: BibleVersion = 'KJV'
): Promise<string> => {
  try {
    // Use the Bible API for all versions now
    return await fetchFromApiBible(book, chapter, verse, version);
  } catch (error) {
    console.error('Error fetching Bible verse:', error);
    throw error;
  }
};

export const fetchBibleVerseRange = async (
  book: string,
  chapter: number,
  startVerse: number,
  endVerse: number,
  version: BibleVersion = 'KJV'
): Promise<string> => {
  try {
    // Use the Bible API for all versions now
    const verses = [];
    for (let v = startVerse; v <= endVerse; v++) {
      const text = await fetchFromApiBible(book, chapter, v, version);
      verses.push(`[${v}] ${text}`);
    }
    return verses.join(' ');
  } catch (error) {
    console.error('Error fetching Bible verse range:', error);
    throw error;
  }
};
